import { makeStyles } from '@fluentui/react-components';
import { isMobile } from 'react-device-detect';

export const useCardActivitiesCarouselStyles = makeStyles({
  carouselContainer: {
    height: isMobile ? '460px' : '310px',
    display: 'flex',
    flexDirection: 'column',
  },
  carouselCard: {
    height: isMobile ? '410px' : '234px',
  },
  bottomCarouselChild: {
    marginTop: 'auto',
  },
});
